import { useMemo } from 'react';
import { Autocomplete } from 'src/components/Autocomplete';
import { Chip } from 'src/components/Chip';
import { TextField } from 'src/components/TextField';
import { useOptionalSession } from 'src/contexts/SessionContext';

interface PackageCategoryFilterProps {
  field: string;
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
}

export const PackageCategoryFilter: React.FC<PackageCategoryFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedValues = value ? String(value).split(',') : [];

  const { session } = useOptionalSession();

  const options = useMemo(
    () => session?.packageTags || [],
    [session?.packageTags]
  );

  if (valueOnly) {
    return selectedValues.length > 0 ? <>{selectedValues.join(', ')}</> : null;
  }

  return (
    <Autocomplete
      multiple
      options={options}
      getOptionLabel={(option) => option}
      value={selectedValues}
      onChange={(_, newValue) => setValue(newValue.join(','))}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={!selectedValues.length ? 'Any' : ''}
        />
      )}
      renderTags={(value: readonly string[], getTagProps) =>
        value.map((option: string, index: number) => {
          const { key, ...tagProps } = getTagProps({ index });
          return <Chip label={option} key={key} {...tagProps} />;
        })
      }
    />
  );
};
